import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { i18n, Trans, useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import Message from "@components/Message";
import responsiveStyle from "@lib/theme/responsiveStyle";

import useOrderData from "../../context/useOrderData";
import getLatestPickupToday from "../../utils/getLatestPickupToday";

const TodaysPickup: FC = () => {
  const { t } = useTranslation();

  const {
    dynamicData: { pickupTimeFrames },
  } = useOrderData();

  const todayPickupTime = getLatestPickupToday(pickupTimeFrames || []);

  if (!todayPickupTime) {
    return null;
  }

  return (
    <Message
      align="start"
      icon={<Icon icon="clock" size="1.875rem" />}
      padding={responsiveStyle({ mobile: "1rem 0.5rem", desktop: "1.25rem 1.25rem" })}
    >
      <Box ml="0.5rem">
        <Box fontSize="0.875rem" fontWeight="300">
          {t("order-sender-courier_pickup_shipment_today")}
        </Box>
        <Box fontSize={responsiveStyle({ mobile: "1rem", desktop: "1.125rem" })} fontWeight="400">
          <Trans i18n={i18n!} i18nKey="order-sender-apply_till" values={{ time: todayPickupTime }} />
        </Box>
      </Box>
    </Message>
  );
};
export default TodaysPickup;
